module.exports = __webpack_public_path__ + "0ba01be26b698ca724db4342c9b1a321.pdf";